import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-settingsAccountSecurityWebauthnListitem',
  templateUrl: './settings-account-security-webauthn-listitem.component.html'
})
export class SettingsAccountSecurityWebauthnListitemComponent implements OnInit {
  @Input('device') device!: any;
  @Output('removeDevice') removeDevice = new EventEmitter();
  translations = <any>{};
  user: User = new User;
  securityMethods: any;


  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  remove() {
    this.removeDevice.emit();
  }
  
}